export type ProjectViewMode = 'kanban' | 'list';

function viewModeStorageKey(userId: string): string {
  return `pm:projectView:${userId}`;
}

export function getStoredProjectViewMode(userId: string | undefined): ProjectViewMode {
  if (!userId) return 'kanban';
  try {
    const raw = localStorage.getItem(viewModeStorageKey(userId));
    return raw === 'list' ? 'list' : 'kanban';
  } catch {
    return 'kanban';
  }
}

export function setStoredProjectViewMode(userId: string | undefined, mode: ProjectViewMode): void {
  if (!userId) return;
  try {
    localStorage.setItem(viewModeStorageKey(userId), mode);
  } catch {
    /* ignore quota / private mode */
  }
}
